module.exports = __webpack_public_path__ + "img/1.04dabd5f.png";